import React, { FC } from 'react';
import { Box, IconButton, useTheme } from '@mui/material';

import { Typography } from '../Typography/Typography';
import { Icon } from '../Icon/Icon';

interface DialogHeaderProps {
  title: string;
  onClose: () => void;
}

export const DialogHeader: FC<DialogHeaderProps> = ({ title, onClose }) => {
  const theme = useTheme();

  return (
    <Box
      p={3}
      display="flex"
      alignItems="center"
      gap={2}
      bgcolor="background.paper"
      borderRadius={`${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`}
    >
      <IconButton onClick={onClose}>
        <Icon
          size="large"
          name="arrow-back-outline"
          fill={theme.palette.primary.main}
        />
      </IconButton>
      <Typography variant="h5" flex={1}>
        {title}
      </Typography>
      <IconButton onClick={onClose}>
        <Icon
          size="large"
          name="close-outline"
          fill={theme.palette.primary.main}
        />
      </IconButton>
    </Box>
  );
};

export default DialogHeader;
